import { render, staticRenderFns } from "./RowMobile.vue?vue&type=template&id=47de8be3"
import script from "./RowMobile.vue?vue&type=script&lang=ts"
export * from "./RowMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47de8be3')) {
      api.createRecord('47de8be3', component.options)
    } else {
      api.reload('47de8be3', component.options)
    }
    module.hot.accept("./RowMobile.vue?vue&type=template&id=47de8be3", function () {
      api.rerender('47de8be3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/RowMobile.vue"
export default component.exports